import tokenData from '../../design-tokens/base-tokens.json';
const MuiRadio = {
    defaultProps: {
        disableRipple: true
    },
    styleOverrides: {
        root: ({ theme }) => ({
            padding: theme.spacing(1.5),
            color: tokenData.tokens.palette.grey.grey500,
            '&:hover': {
                outlineStyle: 'solid',
                outlineWidth: '2px',
                outlineColor: tokenData.tokens.palette.blue.blue500
            },
            '&.Mui-focusVisible': {
                outlineStyle: 'solid',
                outlineWidth: '2px',
                outlineColor: tokenData.tokens.palette.text.text300
            },
            '&.Mui-disabled': {
                color: tokenData.tokens.palette.grey.disabled,
                pointerEvents: 'unset',
                cursor: 'not-allowed',
                '&:hover': {
                    outline: 'none',
                    backgroundColor: 'transparent'
                }
            }
        })
    }
};
export default MuiRadio;
